import { AnalyticsBrowser } from '@segment/analytics-next';

const analytics = new AnalyticsBrowser();

/**
 * Initialize Segment with the write key.
 * Called once from main.js after DOM is ready.
 *
 * @param {string} writeKey - Segment source write key
 */
export function initAnalytics(writeKey) {
  if (!writeKey) return;
  analytics.load({ writeKey });
  analytics.page();
}

/**
 * Track a Segment event. Safe to call before analytics is loaded
 * (calls are buffered by the SDK).
 *
 * @param {string} event - Event name
 * @param {Object} [props={}] - Event properties
 */
export function track(event, props = {}) {
  analytics.track(event, props);
}
